import * as swcHelpers from '@swc/helpers';
import { unwrapResponse } from '../response.js';
import { acceptJson, postJson, authHeader, correlationHeader } from '../shared.js';

const createForCustomer = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, customerId, accessToken, request) {
        return unwrapResponse((yield fetch(`${apiUrl}/customer/${encodeURIComponent(customerId)}/create`, {
            method: 'POST',
            headers: swcHelpers.objectSpread({}, acceptJson, postJson, authHeader(accessToken), correlationHeader()),
            body: JSON.stringify(request)
        })));
    });
    return function createForCustomer(apiUrl, customerId, accessToken, request) {
        return _ref.apply(this, arguments);
    };
}();

export { createForCustomer };
//# sourceMappingURL=create.js.map
